import CommonHeader, { TabConfig } from '@/components/common/CommonHeader';
import { palette } from '@/modules/defines/styles';

const tabs: TabConfig[] = [
  { label: '공간 관리', path: '/space' },
  { label: '유저 관리', path: '/user' },
  { label: '미션 관리', path: '/mission' },
  { label: '리워드 관리', path: '/reward' },
  { label: '통계', path: '/data' },
];

const MaunaHeader = () => {
  return (
    <CommonHeader
      title="Mauna ADMIN"
      backgroundColor={palette.systemGreen}
      hoverColor="#3e8e41"
      tabs={tabs}
      sessionCode="mauna"
      baseRoute="/mauna"
    />
  );
};

export default MaunaHeader;
